<template>
  <div class="page-add" :class="{ 'list-drag': dragaable }">
    <div class="add-title">{{ isEdit ? '编辑试题' : '新增试题' }}</div>
    <el-form class="form" size="small" label-position="right" label-width="95px" :rules="rules" :model="questionForm"
      ref="questionForm">
      <el-row>
        <el-col>
          <el-form-item label="试题类型：" prop="examQuestionType">
            <el-radio v-if="isEdit" :label="questionForm.examQuestionType" :value="questionForm.examQuestionType">{{
              questionForm.examQuestionTypeName }}</el-radio>
            <el-radio-group v-if="!isEdit" v-model="questionForm.examQuestionType" @change="questionTypeChanged">
              <el-radio v-for="item in questionTypeData" :key="item.paramKey" :label="item.paramKey">{{ item.paramValue
                }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item class="form-select" label="试题分类：" prop="questionCategory">
            <el-select v-model="questionForm.questionCategory" placeholder="请选择试题分类" style="width: 100%">
              <el-option v-for="item in questionCategoryData" :key="item.paramKey" :label="item.paramValue"
                :value="item.paramKey"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item label="试题题干：" prop="questionTitle">
            <el-input type="textarea" v-model="questionForm.questionTitle" placeholder="请输入试题题干" maxlength="500"
              autosize></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item label="试题主题：" prop="questionTheme">
            <el-input v-model="questionForm.questionTheme" placeholder="请输入试题主题"
              :disabled="isEdit && $route.query.num != 0"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <template v-if="questionForm.examQuestionType === '0' || questionForm.examQuestionType === '1'">
        <el-row>
          <el-col class="sort-col">
            <el-form-item label="选项排序：" prop="optionOrderType">
              <el-radio-group v-model="questionForm.optionOrderType">
                <el-radio :label="0">随机排序</el-radio>
                <el-radio :label="1">固定排序</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-checkbox v-if="questionForm.optionOrderType == 1" class="check-sort" style="float: right;" v-model="dragaable">拖拽排序</el-checkbox>
          </el-col>
        </el-row>
        <div class="options_content">
          <div v-for="(item, index) in questionForm.examQuestionOptionList" :key="index + refreshFlag"
            class="exam_question__option">
            <el-form-item :label="item.isCorrectAnswer ? '正确选项：' : '其他选项：'"
              :prop="`examQuestionOptionList.${index}.optionTitle`"
              :rules="item.isCorrectAnswer ? rules.correctTitle : rules.otherTitle">
              <el-input v-model="item.optionTitle" :placeholder="item.isCorrectAnswer ? '请输入正确选项' : '请输入其他选项'"
                maxlength="300">
                <!-- 正确选项后面的删除按钮 -->
                <el-button
                  v-if="item.isCorrectAnswer == 1 && questionForm.examQuestionType === '1' && correctOptions.length > 1"
                  slot="append" icon="el-icon-delete" @click="
                    deleteOption(index)
                    "></el-button>
                <!-- 其他选项后面的删除按钮 -->
                <el-button v-if="item.isCorrectAnswer == 0 && (questionForm.examQuestionType === '1' || (questionForm.examQuestionType === '0' && wrongOptions.length > 1)) " slot="append"
                  icon="el-icon-delete" @click="
                    deleteOption(index)
                    "></el-button>
              </el-input>
            </el-form-item>
          </div>
          <el-row>
            <el-col>
              <el-form-item class="center">
                <butn v-if="questionForm.examQuestionType === '1' && correctOptions.length < 6" class="option-add"
                  title="新增正确选项" @click="addNewOption(1)"></butn>
                <butn v-if="wrongOptions.length < 9" class="option-add" title="新增其他选项" @click="addNewOption(0)"></butn>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </template>
      
      <template v-else-if="questionForm.examQuestionType === '2'">
        <el-row>
          <el-col>
            <el-form-item label="正确选项：">
              <el-radio-group v-model="tfFlag">
                <el-radio v-for="item in questionForm.examQuestionOptionList" :key="item.optionTitle"
                  :label="item.optionTitle">{{ item.optionTitle }}</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
      </template>
      <template v-else></template>
      <el-row>
        <el-col>
          <el-form-item class="center handle">
            <el-button @click="resetForm">重置</el-button>
            <el-button @click="goBack">返回</el-button>
            <el-button type="primary" @click="submit">提交</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import butn from "@/components/button/index";
import { getSysParamByTypes } from "@/api/sysParam";
import { Confirm } from "@/components/Confirm";
import { saveQuestion, getQuestionInfo, updateQuestion } from "@/api/examQuestion";
import { deepClone } from "@/utils/clone";
import { setItem } from "@/utils/storage.js";
import Sortable from "sortablejs";
export default {
  name: "examQuestionAdd", 
  components: {
    butn,
  },
  data() {
    return {
      questionForm: {
        examQuestionType: "",
        questionCategory: "",
        questionTitle: "",
        questionTheme: '',
        optionOrderType: 0,
        examQuestionOptionList: [
          {
            isCorrectAnswer: 1,
            optionTitle: "",
          },
          {
            isCorrectAnswer: 0,
            optionTitle: "",
          },
        ],
      },
      rules: {
        questionCategory: [
          {
            required: true,
            message: "请选择试题分类",
            trigger: ["blur", "change"],
          },
        ],
        questionTitle: [
          {
            required: true,
            message: "请输入试题题干",
            trigger: ["blur", "change"],
          },
        ],
        correctTitle: [
          {
            required: true,
            message: "请输入正确选项",
            trigger: ["blur", "change"],
          },
        ],
        otherTitle: [
          {
            required: true,
            message: "请输入其他选项",
            trigger: ["blur", "change"],
          },
        ],
        optionOrderType: [
          {
            required: true,
            message: "请选择选项排序",
            trigger: ["blur", "change"],
          },
        ]
      },

      questionTypeData: [],
      questionCategoryData: [],
      tfFlag: "正确",
      dragaable: false,
      refreshFlag: new Date().getTime(),
      isEdit: false,
    };
  },
  created() {
    this.getSysParamByTypes(["EXAM_QUESTION_CATEGORY", "EXAM_QUESTION_TYPE"]);
    if (this.$route.query.id) {
      this.isEdit = true;
      getQuestionInfo(this.$route.query.id).then((res) => {
        if (!res || res.code != 0) return;
        let { data } = res;
        data.examQuestionType = data.examQuestionType.toString();
        data.questionCategory = data.questionCategory.toString();
        this.questionForm = data;
        this.questionForm.examQuestionOptionList = deepClone(data.examQuestionOptionList);
        if (data.examQuestionType === "2") {
          // 获取判断题的正确答案
          for (const item of data.examQuestionOptionList) {
            if (item.isCorrectAnswer) {
              this.tfFlag = item.optionTitle;
              break;
            }
          }
        }
      });
    }

  },
  computed: {
    correctOptions() {
      return this.questionForm.examQuestionOptionList.filter(
        (ele) => ele && ele.isCorrectAnswer === 1
      );
    },
    wrongOptions() {
      return this.questionForm.examQuestionOptionList.filter(
        (ele) => ele && ele.isCorrectAnswer === 0
      );
    },
  },
  watch: {
    tfFlag(val) {
      if (val === "正确") {
        this.questionForm.examQuestionOptionList[0].isCorrectAnswer = 1;
        this.questionForm.examQuestionOptionList[1].isCorrectAnswer = 0;
      } else {
        this.questionForm.examQuestionOptionList[0].isCorrectAnswer = 0;
        this.questionForm.examQuestionOptionList[1].isCorrectAnswer = 1;
      }
    },
    'questionForm.optionOrderType'(val, oldVal) {
      this.dragaable = val === 1;
      if (this.isEdit) {
        if (oldVal === 1 && val === 0 ) {
          this.$message.warning('编辑试题，不可再进行随机排序')
          this.questionForm.optionOrderType = oldVal;
        }
      }
    },
    dragaable() {
      this.rowDrop(this.dragaable)
    },
  },
  methods: {
    goBack() {
      this.$router.push('/examQuestion');
    },
    // 获取多个数据字典
    getSysParamByTypes(types) {
      getSysParamByTypes({ types: types }).then((res) => {
        if (!res || res.code != 0) return;
        this.questionCategoryData = res.data["EXAM_QUESTION_CATEGORY"];
        this.questionTypeData = res.data["EXAM_QUESTION_TYPE"];
        this.questionForm.examQuestionType = this.questionTypeData[0].paramKey;
      });
    },
    // 新增选项
    addNewOption(isCorrect) {
      this.questionForm.examQuestionOptionList.push({
        isCorrectAnswer: isCorrect,
        optionTitle: "",
      });
    },
    deleteOption(index) {
      this.questionForm.examQuestionOptionList.splice(index, 1);
    },
    // 试题类型改变
    questionTypeChanged(val) {
      if (val === "2") {
        this.questionForm.optionOrderType = 0
        this.questionForm.examQuestionOptionList = [
          {
            isCorrectAnswer: 1,
            optionTitle: "正确",
          },
          {
            isCorrectAnswer: 0,
            optionTitle: "错误",
          },
        ];
      } else if (val === "1") {
        this.questionForm.examQuestionOptionList = [
          {
            isCorrectAnswer: 1,
            optionTitle: "",
          },
        ];
      } else if (val === "0") {
        this.questionForm.examQuestionOptionList = [
          {
            isCorrectAnswer: 1,
            optionTitle: "",
          },
          {
            isCorrectAnswer: 0,
            optionTitle: "",
          },
        ];
      }
      this.$refs["questionForm"].clearValidate();
    },
    // 重置表单
    async resetForm() {
      const text = "确定重置吗?";
      try {
        await Confirm(text, "系统提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        });
        this.$refs["questionForm"].resetFields();
        this.questionForm.examQuestionOptionList = [
          {
            isCorrectAnswer: 1,
            optionTitle: "",
          },
          {
            isCorrectAnswer: 0,
            optionTitle: "",
          },
        ];
        this.questionForm.examQuestionType = this.questionTypeData[0].paramKey;
      } catch (error) {
        if (error === "cancel") return;
      }
    },
    // 提交
    submit() {
      let params = deepClone(this.questionForm);
      if (this.questionForm.examQuestionType == 1) {
        let array = [...this.questionForm.examQuestionOptionList];
        params.examQuestionOptionList = array.filter(
          (ele) => !!ele.optionTitle
        );
      }
      this.$refs["questionForm"].validate((res) => {
        if (res) {
          let api = saveQuestion;
          if (this.isEdit) {
            api = updateQuestion;
          }
          api(params).then((res) => {
            if (!res || res.code != 0) return;
            this.$message({
              message: `试题${this.isEdit ? "编辑" : "新增"}成功`,
              type: "success",
            });
            setItem(this.REFRESH_FLAG, true);
            Object.assign(this.$data.questionForm, this.$options.data().questionForm);
            this.questionForm.examQuestionType = this.questionTypeData[0].paramKey;
            this.$nextTick(() => {
              this.$refs["questionForm"].clearValidate();
            })
            this.goBack();
          });
        }
      });
    },

    // 拖拽排序
    rowDrop(flag) {
      if (!flag) {
        // 关闭拖拽功能时销毁 Sortable 对象
        if (this.sortableInstance) {
          this.sortableInstance.destroy();
          this.sortableInstance = null;
        }
        return;
      }
      const optionsContainer = document.querySelector('.options_content');
      if (!optionsContainer) return;
      // 如果已存在实例，则先销毁
      if (this.sortableInstance) {
        this.sortableInstance.destroy();
      }
      const _this = this;
      this.sortableInstance = new Sortable(optionsContainer, {
        animation: 150,
        delay: 0,
        sort: true,
        draggable: '.exam_question__option',
        ghostClass: 'sortable-ghost',
        chosenClass: 'sortable-chosen',
        dragClass: 'sortable-drag',

        onEnd({ oldIndex, newIndex }) {
          if (oldIndex === newIndex) return;
          // 直接操作原数组，保证响应性          
          const list = [..._this.questionForm.examQuestionOptionList];
          const movedItem = list.splice(oldIndex, 1)[0];
          list.splice(newIndex, 0, movedItem);
          _this.questionForm.examQuestionOptionList = list;
          _this.refreshFlag = new Date().getTime();
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.center {
  text-align: center;

  &.handle {
    margin-top: 20px;
  }
}

.option-add {
  border-style: dashed;
  color: #96a1b2;
}


.sort-col {
  position: relative;
  .check-sort { 
    position: absolute;
    top: 10px;
    right: 0;
  }
}

.options_content {}
</style>
